import { aggregate } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';
import { usePromoterItemQuery } from '../promoter/usePromoterItemQuery.ts';

export const useFilteredIncompleteEventsCountQuery = ({
  categoryId,
  eventType,
  enabled,
}: {
  categoryId?: number;
  eventType?: 'online' | 'live' | 'secret';
  enabled?: boolean;
}) => {
  const { data } = usePromoterItemQuery();

  return useQuery({
    queryKey: ['incomplete_events', 'filtered_count', { categoryId, eventType, promoterId: data?.id }],
    queryFn: async () => {
      const filter: Record<string, unknown> = {
        promoter: { _eq: data?.id },
      };

      if (categoryId) {
        filter.category = { _eq: categoryId };
      }

      if (eventType) {
        filter.type = { _eq: eventType };
      }

      const result = await directusClient.request(
        aggregate('incomplete_events', {
          aggregate: { count: '*' },
          query: { filter },
        }),
      );

      return Number(result[0]?.count ?? 0);
    },
    enabled: enabled !== false && !!data?.id,
  });
};
